import { ArrowBack, KeyboardArrowRightOutlined } from '@mui/icons-material';
import { Stack, styled } from '@mui/material';
import { Button, FormSaveButton, useWizard } from '@vestwell-frontend/ui';

import { FC } from 'react';

import { CreateGiftState } from '../config';
import { GiftStepState } from '../config/CreateGiftState';

const StyledBackButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(0)
  }
}));

interface ContinueAndBackButtonsProps {
  nextText?: string;
  useNextArrowIcon?: boolean;
}

export const ContinueAndBackButtons: FC<ContinueAndBackButtonsProps> = ({
  nextText = 'Continue',
  useNextArrowIcon = true
}) => {
  const ctx = useWizard<CreateGiftState>();

  const goBack = (event, oldIndex = 0) => {
    const previousIndex =
      oldIndex > 0 ? oldIndex - 1 : ctx.hasPrevStep ? ctx.index - 1 : 0;
    const currentStepState = Object.values(GiftStepState)[previousIndex];
    ctx.setState({ ...ctx.state, stepState: currentStepState });
    if (
      !ctx.steps[previousIndex].when({
        ...ctx.state,
        stepState: currentStepState
      }) &&
      previousIndex > 0
    ) {
      goBack(event, previousIndex);
    }
  };

  return (
    <Stack direction='row' justifyContent='space-between'>
      {ctx.hasPrevStep && (
        <StyledBackButton
          onClick={goBack}
          startIcon={<ArrowBack />}
          variant='text'>
          Back
        </StyledBackButton>
      )}
      <FormSaveButton
        endIcon={useNextArrowIcon ? <KeyboardArrowRightOutlined /> : null}>
        {nextText}
      </FormSaveButton>
    </Stack>
  );
};
